import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import PropertyTypesIconMapping from "../../assets/icons/PropertyTypesIconMapping";
import { ReactComponent as AddIcon } from "../../assets/icons/property-type/add.svg";
import { ReactComponent as NextArrowIcon } from "../../assets/icons/slider/next-arrow.svg";
import { ReactComponent as PrevArrowIcon } from "../../assets/icons/slider/prev-arrow.svg";
import { ReactComponent as AmenityIcon } from "../../assets/icons/property-type/amenity.svg";

import { EMPTY_STRING, surveyFiledsTypes } from "../../constants";
import WithSwiper from "../../shared/components/hoc/WithSwiper";
import SwiperControls from "../../shared/components/hoc/SwiperControls";
import { propertyActions, homeActions } from "../../redux/actions";
import PropertyList from "./PropertyList";
import AmenitiesModal from "./AmenitiesModal";
import AddPropertyTypeModal from "./AddPropertyTypeModal";

const { TYPE_CHECKBOX } = surveyFiledsTypes;

// Configuration for the Swiper
const swiperConfig = {
  spaceBetween: 0,
  slidesPerView: 3,
  breakpoints: {
    320: { slidesPerView: 1.01 },
    360: { slidesPerView: 1.07 },
    375: { slidesPerView: 1.12 },
    390: { slidesPerView: 1.18 },
    412: { slidesPerView: 1.25 },
    414: { slidesPerView: 1.27 },
    430: { slidesPerView: 1.32 },
    480: { slidesPerView: 1.7 },
    576: { slidesPerView: 3.3 },
    768: { slidesPerView: 4.45 },
    992: { slidesPerView: 6 },
    1200: { slidesPerView: 7.35 },
    1400: { slidesPerView: 8.4 },
  },
};

const PropertyType = (props) => {
  const {
    allMustHaveAmmenities,
    userPropertyTypes,
    filters,
    setFilters,
    setAmenities,
    allAllowedCountries,
    addPropertyTypeForUser,
    getPropertyTypesByUser,
    getAllMustHaveAmmenities,
  } = props;

  const swiperRef = useRef(null);
  const activeSlideIndexRef = useRef(0);
  const [payload, setPayload] = useState();
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [displayControls, setDisplayControls] = useState(false);
  const [newTypeModalOpen, setNewTypeModalOpen] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [ammenities, setAmmenities] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]);

  const showAmenityModal = () => setIsShow(true);
  const closeAmenityModal = () => setIsShow(false);
  const openNewTypeModal = () => setNewTypeModalOpen(true);
  const closeNewTypeModal = () => setNewTypeModalOpen(false);

  const handleAmenityChange = (amenity) => {
    setSelectedAmenities(amenity);
    setAmenities(amenity);
  };

  const handleFindByAmenities = () => {
    closeAmenityModal();
  };

  const handleChangeFilterPropertyTypes = (id) => {
    activeSlideIndexRef.current = swiperRef.current?.swiper?.activeIndex;

    setFilters((prev) => ({
      ...prev,
      propertyTypeIds: prev.propertyTypeIds.includes(id)
        ? prev.propertyTypeIds.filter((pId) => pId !== id)
        : [...prev.propertyTypeIds, id],
    }));
  };

  // Creating the Swiper HOC instance
  const SwiperComponent = React.memo(WithSwiper(() => null));

  const slides = propertyTypes.map((property, index) => (
    <PropertyList
      key={property.id}
      id={property.id}
      name={property.title}
      propertiesCount={property.propertiesCount}
      icon={PropertyTypesIconMapping[property.icon]}
      handleSelection={handleChangeFilterPropertyTypes}
      selected={filters.propertyTypeIds.includes(property.id)}
    />
  ));

  const handleAddPropertyType = (data) => {
    addPropertyTypeForUser(data, () => {
      activeSlideIndexRef.current = 0;
      closeNewTypeModal();
      getPropertyTypesByUser(payload);
    });
  };

  useEffect(() => {
    setPayload({
      countryIds:
        filters.countryIds.length > 0
          ? filters.countryIds
          : allAllowedCountries.map((country) => country.id),
    });
    // eslint-disable-next-line
  }, [filters.countryIds, allAllowedCountries]);

  useEffect(() => {
    if (allAllowedCountries.length > 0 && payload) {
      getPropertyTypesByUser(payload);
    }
    // eslint-disable-next-line
  }, [payload]);

  const handleWidth = () => {
    setTimeout(() => {
      const pages = document.getElementsByClassName(
        "swiper-pagination-bullet"
      ).length;
      if (pages > 1) {
        setDisplayControls(true);
      } else {
        setDisplayControls(false);
      }
    }, 100);
  };

  useEffect(() => {
    if (userPropertyTypes?.length > 0) {
      setPropertyTypes(userPropertyTypes);
    }
    handleWidth();

    // eslint-disable-next-line
  }, [userPropertyTypes]);

  useEffect(() => {
    const swiperInstance = swiperRef.current?.swiper;
    if (swiperInstance && swiperInstance.initialized) {
      swiperInstance.slideTo(activeSlideIndexRef.current, 0); // 0 duration for instant jump
    }
  }, [slides]);

  useEffect(() => {
    if (allMustHaveAmmenities) {
      setAmmenities(allMustHaveAmmenities);
    }
    // eslint-disable-next-line
  }, [allMustHaveAmmenities]);

  useEffect(() => {
    getAllMustHaveAmmenities();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container my-5">
      <AddPropertyTypeModal
        onClose={closeNewTypeModal}
        show={newTypeModalOpen}
        userPropertyTypes={userPropertyTypes}
        handleAdd={handleAddPropertyType}
      />
      <div className="row align-items-center">
        <div className="col-4 col-sm-1 d-flex justify-content-end property-type-slider-controler">
          <PrevArrowIcon className="swiper-button-prev slider-arrow" />
        </div>
        <div className="col-4 col-sm-9">
          <div className="property-type-slider">
            <SwiperComponent
              slides={slides}
              swiperRef={swiperRef}
              swiperConfig={swiperConfig}
            />
          </div>
        </div>
        <div className="col-4 col-sm-1 d-flex align-items-center justify-content-start property-type-slider-controler">
          <div>
            <NextArrowIcon className="swiper-button-next slider-arrow" />
          </div>
          <div className="ms-5">
            <AddIcon className="pointer " onClick={openNewTypeModal} />
          </div>
          <div className="ms-2 d-none d-lg-block">
            <AmenityIcon className="pointer " onClick={showAmenityModal} />
          </div>
        </div>
        <div className="col-12 d-flex align-items-center justify-content-center d-block d-lg-none">
          <div className="">
            <AmenityIcon className="pointer " onClick={showAmenityModal} />
          </div>
        </div>
      </div>
      <div
        className={`property-type-slider-controls ${
          displayControls ? "visible" : "invisible"
        }`}
      >
        <SwiperControls />
      </div>
      <div className="recommended-property container">
        <AmenitiesModal
          show={isShow}
          ammenities={ammenities}
          closeModal={closeAmenityModal}
          selectedAmenities={selectedAmenities}
          handleAmenityChange={handleAmenityChange}
          handleFindByAmenities={handleFindByAmenities}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userPropertyTypes: state.propertyReducer.userPropertyTypes,
  allAllowedCountries: state.homeReducer.allAllowedCountries,
  allMustHaveAmmenities: state.homeReducer.allMustHaveAmmenities,
});

const mapDispatchToProps = (dispatch) => ({
  getPropertyTypesByUser: (data) =>
    dispatch(propertyActions.getPropertyTypesByUser(data)),
  addPropertyTypeForUser: (data, func) =>
    dispatch(propertyActions.addPropertyTypeForUser(data, func)),
  getAllMustHaveAmmenities: () =>
    dispatch(homeActions.getAllMustHaveAmmenities()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PropertyType);
